import React, { useCallback, useEffect, useState } from "react";
import _ from 'lodash'
import { StackActions, useIsFocused, useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import i18n from "utils/i18n";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import { AppRoutes } from "navigations/app-routes";
import Text from "theme/Text";
import { StyleSheet, View } from 'react-native'
import { colorList } from 'utils/colors'
import { shadow, ThemedValues } from 'styles/themed'
import { SafeAreaView } from 'react-native-safe-area-context'
import ScanButton from './_components/ScanButton'
import ObjectBooking, { getCurrentBooking } from 'utils/objects/booking'
import IndexCalendarSceneBlock from 'scenes/home/home/_scene_blocks/index/calendar'
import IndexFavouritePresenceSceneBlock from 'scenes/home/home/_scene_blocks/index/favourite_presence'
import HelperEmployee from 'utils/HelperEmployee'
import PushNotifications from 'services/push-notifications/PushNotifications'
import HelperString from 'utils/helper-string'
import IndexUpdateSceneBlock from 'scenes/home/home/_scene_blocks/index/update'
import HelperPlatform from 'utils/helper-platform'
import ThemedPressable from 'components/atoms/ThemedPressable'
import { MODE_SCAN_IN, MODE_SCAN_OUT } from 'utils/constants/qrcode-constants'
import { TESTID } from '_shared/config/testID';
import { ThemedTopNavigationStyles } from 'styles/components/atoms/ThemedTopNavigation'
import Qrcode_Presence from 'utils/qrcode/Presence'
import { settingsConstants } from 'utils/constants/settings-constants'
import { scanThroughConstants } from 'utils/constants/scan-constants'
import selectSetting from 'services/redux/data/selectors/selectSetting'
import selectBookings from 'services/redux/data/selectors/selectBookings'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { useEmployeeScanStatus } from 'utils/objects/employee-scan'
import useDatetime from 'utils/hooks/use-datetime'
import FetchEmployeeTransport from 'utils/fetch/FetchEmployeeTransport'
import HelperDate, { dateFormat } from 'utils/helper-date'
import VStack from 'components/atoms/stack/VStack'
import ObjectEmployee from 'utils/objects/employee'
import ParkingStatuses from 'scenes/home/home/_components/ParkingStatuses'
import useRouteHomeHelper from 'utils/hooks/use-route-home-helper'
import AppMessages from 'scenes/home/home/_components/AppMessages'
import { useIsSmallDevice } from 'utils/helper-device'

const HomeHomeIndexScene = () => {
	
	useRouteHomeHelper();
	
	const isFocused = useIsFocused();
	const navigation = useNavigation();
	const isSmallDevice = useIsSmallDevice();
	
	const _serverTimeDifferenceSeconds = useSelector( state => {
		return state.data[dataConstants.SERVER_TIME_DIFFERENCE_SECONDS];
	} ); // do not remove, required for reloading
	const _serverTimeZoneOffset = useSelector( state => {
		return state.data[dataConstants.SERVER_TIMEZONE_OFFSET];
	} ); // do not remove, required for reloading
	const _serverTimezone = useSelector( state => {
		return state.data[dataConstants.SERVER_TIMEZONE];
	} ); // do not remove, required for reloading
	const _settingScanInType = useSelector( state => {
		return selectSetting(state, settingsConstants.SCAN_IN_TYPE);
	} )
	const _settingScanOutType = useSelector( state => {
		return selectSetting(state, settingsConstants.SCAN_OUT_TYPE);
	} )
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} );
	const _employeeTransports = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE_TRANSPORTS];
	} )
	const _bookings = useSelector( selectBookings );
	const datetime = useDatetime();
	
	const { isScanningInEnabled, isScanningOutEnabled, isScanningEnabled, scanMode: scanModeNonRoute, scanInThrough, scanInBuilding } = useEmployeeScanStatus();
	
	const [ bookings, setBookings ] = useState( {} )
	const [ scanLoading, setScanLoading ] = useState( false )
	const [ transportLoading, setTransportLoading ] = useState( true )
	const [ selectedDate, setSelectedDate ] = useState( HelperDate.date() )
	
	const onPressQrCodeButton = useCallback(
		() => {
			navigation.navigate( AppRoutes.QRCODE_SCAN );
		}
	,[]);

	const onPressScanInButton = () => {
		if( _settingScanInType === scanThroughConstants.QRCODE ) {
			navigation.navigate( AppRoutes.QRCODE_SCAN, { scanMode: MODE_SCAN_IN } );
			return;
		}
		
		const booking = getCurrentBooking( bookings )
		const buildingGuid = _.get( booking, ['building', 'guid'], null );
		
		if( buildingGuid !== null ) {
			const qrCode = `building:${buildingGuid}`;
			
			setScanLoading( true )
			
			Qrcode_Presence.scanIn( qrCode,
				() => {
					setScanLoading( false )
					
					navigation.navigate( AppRoutes.PRESENCE_TRANSPORT, {
						navigatedFromScan: true,
						scanMode: MODE_SCAN_IN,
						message: i18n.t( `notification.scan_success.${ MODE_SCAN_IN }` ),
						buildingGuid: buildingGuid
					});
				},
				setScanLoading.bind( this, false ),
			);
		}
	}
	
	const onPressScanOutButton = () => {
		if( _settingScanOutType === scanThroughConstants.QRCODE ) {
			navigation.navigate( AppRoutes.QRCODE_SCAN, { scanMode: MODE_SCAN_OUT } );
			return;
		}
		
		const booking = getCurrentBooking( bookings )
		const buildingGuid = _.get( booking, ['building', 'guid'], null );
		
		if( buildingGuid !== null ) {
			const qrCode = `building:${buildingGuid}`;
			
			setScanLoading( true )
			
			Qrcode_Presence.scanOut( qrCode,
				() => {
					setScanLoading( false )
					
					navigation.navigate( AppRoutes.PRESENCE_TRANSPORT, {
						navigatedFromScan: true,
						scanMode: MODE_SCAN_OUT,
						message: i18n.t( `notification.scan_success.${ MODE_SCAN_OUT }` ),
						buildingGuid: buildingGuid
					});
				},
				setScanLoading.bind( this, false ),
			);
		}
	}
	
	const openProfileOnError = () => {
		navigation.navigate( AppRoutes.MORE_PROFILE, { profileError: 'yes' } )
	}
	
	const onSelectDate = ( date ) => {
		setSelectedDate( date );
	}
	
	const validateProfile = () => {
		if( !_.isEmpty( _employee ) ) {
			const errors = HelperEmployee.isValid( _employee );
			
			if( errors.length > 0 ) {
				openProfileOnError();
				return;
			}
			
			if( ObjectEmployee.isScanner( _employee ) ) {
				navigation.dispatch(
					StackActions.replace( AppRoutes.LUNCH_SCANNER )
				);
			}
		}
	}
	
	const fetchEmployeeTransports = () => {
		FetchEmployeeTransport.fetch({
			/* TODO optimize */
			dispatchDataToStore: true,
			callbackError: () => {
			},
			callbackSuccess: () => {
				setTimeout( () => {
					return setTransportLoading(false);
				}, 500 ); // don't scare the user directly
			}
		});
	}
	
	useEffect( () => {
		fetchEmployeeTransports();
	}, [] );
	
	useEffect( () => {
		if( transportLoading === false ) {
			if( isScanningInEnabled && scanInThrough === 'automatic' && _.isEmpty( _employeeTransports ) ) {
				navigation.navigate( AppRoutes.PRESENCE_TRANSPORT, {
					navigatedFromScanForced: true,
					message: i18n.t( `notification.scan_success.${ scanInThrough }` ),
					buildingGuid: _.get( scanInBuilding, 'guid', null )
				});
			}
		}
	}, [ transportLoading, isScanningInEnabled, scanInThrough, _employeeTransports ])
	
	useEffect( () => {
		return validateProfile();
	}, [ _employee ] );
	
	useEffect( () => {
		// Get the current date
		const currentDate = HelperDate.date().format( dateFormat.DATE );
		
		// Create the booking data
		setBookings( ObjectBooking.filterAccepted( _.filter( _bookings, { 'booking_date': currentDate } ) ) );
		
	}, [ _bookings ] );
	
	useEffect( () => {
		if( isFocused ) {
			if( HelperDate.fn.isToday( selectedDate ) ) {
				setSelectedDate( HelperDate.date() );
			}
		}
	}, [ isFocused ] );
	
	let employeeName = _.get( _employee, 'name', '');
	if( _.includes( employeeName, ' ' ) ) {
		employeeName = employeeName.substring( 0, employeeName.indexOf( " " ) );
	}
	
	const topNavigationView = (
		<View
			key={ HelperString.hash( 'top-navigation-view' ) }
			style={ [ ThemedTopNavigationStyles.topNavigation, styles.headerContainer ] }>
			
			<SafeAreaView
				edges={[ 'top' ]}
				style={ styles.safeAreaViewFlex0BackgroundColorTransparent }
			/>
			
			<View
				key={ HelperString.hash( 'greeting-container' ) }
				style={ styles.headerGreetingContainer }
				testID={ TESTID.HOME.HOME.INDEX.WELCOME_GREETING_VIEW }>
				
				<Text key={ 'greeting' } style={[ styles.headerGreetingText, isSmallDevice ? styles.headerGreetingTextMobile : null ]}>
					{ i18n.t( 'page.home.greeting', { name: employeeName } ) }
				</Text>
				
				{ HelperPlatform.isNotWeb() && (
					<View
						key={ HelperString.hash( 'qrcode' ) }
						style={ styles.headerQrCodeContainer }>
						
						<ThemedPressable onPress={ onPressQrCodeButton }>
							<Icon icon={ IconSystemConstants.QRCODE } style={ styles.headerQrCode }></Icon>
						</ThemedPressable>
					</View>
				) }
			</View>
			
			<ScanButton
				enabled={ _.size( bookings ) > 0 }
				onPressScanInButton={ onPressScanInButton }
				onPressScanOutButton={ onPressScanOutButton }
				loading={ scanLoading }
			/>
		</View>
	);
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<PushNotifications />
			
			<ThemedLayout
				contentWidth="narrow"
				topNavigation={ false }
				topNavigationView={ topNavigationView }
				enableScrollView={ true }
				testID={ TESTID.HOME.HOME.SCREENS.INDEX }>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					{/* Update block */}
					{ HelperPlatform.isNotWeb() && (
						<IndexUpdateSceneBlock isFocused={ isFocused } />
					)}
					
					{/* Parking statuses */}
					<ParkingStatuses />
					
					{/* App messages */}
					<AppMessages />
					
					<IndexCalendarSceneBlock
						key={ HelperString.hash( "calender_scene_block" ) }
						date={ selectedDate }
						onSelectDate={ onSelectDate }
					/>
					<IndexFavouritePresenceSceneBlock
						key={ HelperString.hash( "favourite_presence_scene_block" ) }
						selectedDate={ selectedDate }
					/>
				</VStack>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

const styles = StyleSheet.create({
	safeAreaViewFlex0BackgroundColorTransparent: {
		flex: 0,
		backgroundColor: 'transparent',
	},
	headerContainer: {
		paddingHorizontal: 12,
		backgroundColor: 'transparent'
	},
	
	headerGreetingContainer: {
		backgroundColor: 'transparent',
		width: '100%',
		minHeight: 44,
		justifyContent: 'center',
		paddingHorizontal: 44,
	},
	
	headerGreetingText: {
		color: colorList.TITLE.primary,
		fontSize: 26,
		fontWeight: '700',
		textAlign: 'center',
	},
	headerGreetingTextMobile: {
		fontSize: 24,
	},
	headerButtonContainer: {
		position: 'absolute',
		right: 2,
		top: 10,
		flex: 1,
		flexDirection: 'row',
		borderRadius: ThemedValues.borderRadius,
		...shadow({
			elevation: 1,
			color: colorList.TITLE.primary,
			opacity: 0.25,
			radius: 2.84,
			offsetWidth: 0,
			offsetHeight: 1
		})
	},
	headerButton:{
		marginLeft: 8
	},
	
	headerQrCodeContainer: {
		position: 'absolute',
		right: 0,
		top: 5,
		width: 32,
		height: 32
	},
	
	headerQrCode: {
		color: colorList.PRIMARY.dark,
		fontSize: 24
	}
});

export default HomeHomeIndexScene
